import * as S from './styled';
import moment from 'moment/moment';
import React from 'react';


const DurationDisplay = ({ startTime, currentTime }) => {

  const elapsed = Math.max(
    0,
    currentTime && startTime ? currentTime.diff(startTime) : 0
  );

  return <S.ContentItemData>{moment.utc(elapsed).format('HH:mm:ss')}</S.ContentItemData>;

};

export default DurationDisplay;